let PWA_CONSTANT = JSON.parse(window._siteProps_.props.countryConstant);
import { EndPoints } from "../../config/apiEndpoints";

export const {
  COUNTRY_CODE,
  PHONE_DIGIT,
  CURRENCY_SYMBOL,
  CURRENCY_CODE,
  BLOCKED_PATHS,
  GOOGLE_MAP_COUNTRY,
  DEFAULT_STORE,
  TNC,
  TNC_URL,
  DEFAULT_TNC_URL,
  SHOW_LOAGIN_WITH_PASSWORD,
  DEFAULT_MENU,
  GOOGLE_SITE_VERIFICATION_ID,
  HELP_DESK_NO,
} = PWA_CONSTANT;

export const PHONE_PLACEHOLDER = PHONE_DIGIT === 9 ? "XXXXXXXX" : "XXXXXXXXXX";
export const CURRENCY_STYLE = CURRENCY_CODE.toLowerCase();
export const IS_INDIA = CURRENCY_CODE === "INR";
export const IS_SL = CURRENCY_CODE === "LKR";
export const IS_BG = CURRENCY_CODE === "BDT";
export const IS_WALLET_BLOCKED = IS_SL;
export const MAP_COUNTRY = GOOGLE_MAP_COUNTRY;
export const DEFAULT_STORE_ID_SERVER_VAL = DEFAULT_STORE;

export let currencyIconClass;
switch (CURRENCY_CODE) {
  case "INR":
    currencyIconClass = "rs";
    break;
  case "LKR":
    currencyIconClass = "";
    break;
  default:
    currencyIconClass = "rs";
}

export const PAYMENT_ACTION = {
  COD_OTP: "COD_OTP",
  EV_PIN: "EV_PIN",
  EV_OTP: "EV_OTP",
  REDIRECT: "REDIRECT",
  AMZNPAY_CHARGE_STATUS: "AMZNPAY_CHARGE_STATUS",
  PROCESS_PAYMENT: "PROCESS_PAYMENT",
  PAY_PAGE: "PAY_PAGE",
  REMOVE_PROMO: "REMOVE_PROMO",
  REFUND_PAGE: "REFUND_PAGE",
  PAYTM_ADD_MONEY: "PAYTM_ADD_MONEY",
  PAYTM_WITHDRAW_MONEY: "PAYTM_WITHDRAW_MONEY",
  THANKYOU: "THANKYOU",
  PAYTM_LINK: "PAYTM_LINK",
  UNIFIED_PAYMENT: "UNIFIED_PAYMENT_ACTION",
};

export const UNIFIED_ACTION = {
  POLL: "poll",
  OTP: "otp",
  REDIRECT: "redirect",
  INTENT: "intent",
  OTPRETRY: "otp_retry",
};

export const PAYMENT_GATEWAY = {
  PAYU: "PAYU",
  PAYTM_PG: "PAYTM_PG",
  BILLDESK: "BILLDESK",
  PAYTM_WALLET: "PAYTM_WALLET",
  GLOBALPAY: "GLOBALPAY",
  SSLCOMMERZ: "SSLCOMMERZ",
  RAZORPAY: "RAZORPAY",
};

export const PAYMENT_METHOD = {
  CITRUS_WALLET: "PIGGYBANK",
  OTHER_WALLETS: "CASHCRD",
  NET_BANKING: "NB",
  EVOUCHER: "EVOUCHER",
  CASH: "CASH",
  CREDIT_CARD: "CC",
  DEBIT_CARD: "DC",
  AMAZON_WALLET: "AMZPAY_WALLET",
  PAYTM_WALLET: "PAYTM_WALLET",
  UPI_WALLET: "UPI_WALLET",
  MOBILE_BANKING: "MB",
  WALLET: "WALLET",
};

export const PAYMENT_STATUS = {
  PENDING: "PENDING",
  SUCCESS: "SUCCESS",
  TXN_SUCCESS: "TXN_SUCCESS",
};

/**
 * Previously we used to have the customer as mandatory.
 * It is no longer so.
 * So we pass this default email to the API's where it is required.
 */
export const DEFAULT_USER_EMAIL = "pwa.jfl@gmail.com";

export const PAYMENT_TRANSACTION_URL =
  EndPoints?.envConfig?.PAYMENT_TRANSACTION_URL || "/paymentTransaction";

export const RESPONSE = {
  SUCCESS: "SUCCESS",
  FAILED: "FAILED",
  WAIT: "WAIT",
  INPROGRESS: "IN_PROGRESS",
};

export const common = {
  dinein: "Dine-in",
  internalServerError: "Something Went Wrong. Please Try Again.",
  miniAppExitError:
    "We are unable to login , Please retry or exit to native app",
  networkTimeOut: "There seems to be network issue. Retrying ....",
  ops: "Ooops...",
  locationAccess: "Location Access",
  ok: "Ok",
  delete: "Delete",
  retry: "Retry",
  EDV: "Everyday Value Offer",
  EDV_BD: "Family Celebration",
  looksInternalServerError:
    "Sorry, we are facing some temporary issues with the store selected. Please select a different store",
  tryAgain: "Try Again",
  enterVerificationCode: "Please enter verification code sent by SMS",
  enterOTP: "Please enter OTP sent by SMS",
  em: "Explore Menu",
  menu: "Menu",
  orderNo: "Order No",
  orderNow: "Order Now",
  oops: "Oops!",
  mobilePlaceholder: "Mobile No*",
  emailAddressPlaceholder: "Email Address",
  noFavourite: "No Favourites Set",
  addFavourite: "Add your favourite item from menu to see them here",
  dismiss: "Dismiss",
  reviewCart: "Review Cart",
  advanceOrderMessage:
    "Store is currently offline, please feel free to browse menu.",
  noResult: "No result found on your search!",
  paymentFailed: "Payment Failed. Please try again.",
  offer: "Offer",
  applied: "Applied",
  youSaved: "You Saved",
  pay: "Pay",
  rechargeAmount: "Enter Recharge Amount",
  balance: "Balance",
  minimumAmountRequired: "Minimum Amount Required",
  headerLinkTitle: "Link Wallet",
  paymentConfirmation: "Confirm Payment",
  noInternetConnection: "Internet connection Lost",
  acceptTNC: "Please Accept Terms and Conditions First",
  cancelMsg: "Are you sure you would want to cancel your order with Domino's?",
  trackingMsg:
    "Your order is with us. We will notify you once tracking is available.",
  trackingInfoNotAvailable:
    "Tracking Information is not available for this order yet. Please try again after some time.",
  CANCELLED: "CANCELLED",
  FAILED: "FAILED",
  INPROCESS: "INPROCESS",
  ORDER_CANCELLED: "Order cancelled",
  ORDER_FAILED: "Order Failed",
  PENDING_CONFIRMATION: "Pending Confirmation",
  enableCookies:
    "Your browser has cookies disabled. Make sure that your cookies are enabled and refresh again.",
  cookiesDisabledHeader: "Cookies are disabled",
  learnMore: "Learn More",
  apiCommonErrorMsg: "You have been logged out. Please login again.",
  apiMiniAppError: "You have been logged out. Please exit.",
  errorWallet:
    "Wallet can't be choosen with CASH OR EGV, Please change PaymentMode",
  note: "Note",
  duplicateOrderMessage:
    "Dear Customer, We have noticed that you have placed an order with us in the past 30 minutes. Do you wish to continue and place a new order?",
  dominosCares: "Domino's Cares",
  okGotIt: "OK, GOT IT",
  loggedIn: "You are successfully Logged In",
  errorMsg: "We’re sorry. The link you clicked is not a working one!",
  savenContLabel: "saveAndContinue",
  addAddresslabel: "add_address",
  locationNudgeMessage:
    "Select your location to help us find the nearest store",
  addedInCart: "Added in cart",
  requiredField: "This field cannot be left empty",
  otpValidationFailedNewFlow:
    "Validation failed. please verify your number again.",
};

export const MINIAPP = {
  PAYTM: "PAYTM",
  GPAY: "GPAY",
};

export const ORDER_TYPE = {
  DELIVERY: "D", //delivery
  TAKEAWAY: "T",
  PICKUP: "P", //pickup
  IRCTC: "IRCTC",
  DINEIN: "DINEIN", //dineIn
  CURB: "CURB", //drivenpick
};

export const DEFAULT_TXN_STATUS_TIME = {
  totalTime: 80,
  nextCallTime: 3,
};

export const wallet = {
  headerText: "Domino's Wallet",
  cheesyRewardsHeaderText: "Cheesy Rewards History",
  walletBalHeading: "DOMINO'S POINTS BALANCE",
  footerText_1: "You can use this amount to place an order.",
  footerText_2: "On Domino's Web Site, Mobile Site & App",
  statement: "Statement",
  expiresOn: "Expires on",
  faq: "Frequently Asked Questions",
  deselectWalletMsg:
    "To select other payment modes please uncheck Domino's Wallet",
};

export const popDelayTime = {
  time_5sec: 5000,
  time_10sec: 10000,
  time_20sec: 20000,
};

export const notApplicableData = {
  errorMsg:
    "This coupon is not valid at the moment. Choose Pay Now to remove promo (any free items will be removed) and pay full amount. Or Choose Dismiss to retry with a different payment method",
  header: "Offer not applicable",
};

export const VWO_VARIANT_NEXTGEN_HOMEPAGE_HEADER_NAME =
  "next_gen_home_ab_experiment_v11";
export const VWO_NEXTGEN_HOMEPAGE_EXPERIMENT = "NextGenHomePageUpdatedV11";
export const PAYMENT_HEADER_VARIENT = "newpaymentui";

export const SENTINEL = {
  IS_GET_SENTINELIZED: window._siteProps_?.props?.isGetSentinelized
    ? JSON.parse(window._siteProps_?.props?.isGetSentinelized)
    : false,
  SENTINELIZED_TIMEOUT: window._siteProps_?.props?.sentinelizedTimeout
    ? JSON.parse(window._siteProps_?.props?.sentinelizedTimeout)
    : 4000,
  PUBLIC_KEY: window._siteProps_?.props?.sentinelPubKey,
  CLIENT_ID: window._siteProps_?.props?.sentinelClientId,
  CLIENT_SECRET: window._siteProps_?.props?.sentinelClientSecret,
};

export const SAVE_CARD_FEATURE = {
  isSavedCardFeatureDisabled : window._siteProps_?.props?.isSavedCardFeatureDisabled === "true",
  saveCardDefaultCheckbox : window._siteProps_?.props?.saveCardDefaultCheckbox === "true"
}
